module.exports = __webpack_public_path__ + "img/22n.dff48947.png";